import { ajax } from '../modules/ajax.js';
import { showModal } from '../modules/modal.js';

document.addEventListener("DOMContentLoaded", () => {
    const sealAddDialog = document.getElementById('sealAddDialog');
    const cancelAddButton = document.getElementById('cancel-sealAddDialog');
    const acceptAddButton = document.getElementById('accept-sealAddDialog');
    const addSealNumberButton = document.getElementById('add-seal-number');
    const sealNumbersContainer = document.getElementById('sealNumbersContainer');
    const addSealLocationInput = document.getElementById('add-seal-location');
    const addSealButton = document.querySelector('.js-seal-add');

    const alterParticipantButton = document.getElementById('alter-participant');
    const participantDialog = document.getElementById('participants-dialog');
    const cancelParticipantButton = document.getElementById('cancel-participants-dialog');
    const saveParticipantButton = document.getElementById('save-participants-dialog');
    const participantsContainer = document.querySelector('#participants-dialog .dialog__body');

    const sealsDialog = document.getElementById('sealDialog');
    const sendDialog = document.getElementById('notificationDialog');
    const createAgentDialog = document.getElementById('newAgent');
    const confirmTaskDialog = document.getElementById('confirmTask');
    const completeTaskModal = document.getElementById('completeTaskModal');

    const actActionBtn = document.getElementById('actAction');
    const openButton = document.querySelectorAll('.js-seal-replace');
    const sendActButton = document.getElementById('sendAct');
    const createAgentButton = document.getElementById('createAgent');
    const completeTaskButton = document.getElementById('completeTask');

    const acceptButton = document.getElementById('accept-sealDialog');
    const cancelButton = document.getElementById('cancel-sealDialog');
    const sendEmailButton = document.getElementById('send-email');
    const cancelEmailButton = document.getElementById('cancel-sendDialog');
    const acceptAgentButton = document.getElementById('accept-agentDialog');
    const cancelAgentButton = document.getElementById('cancel-agentDialog');
    const completeConfirmButton = document.getElementById('complete-confirmDialog');
    const execConfirmButton = document.getElementById('exec-confirmDialog');
    const cancelConfirmButton = document.getElementById('cancel-confirmDialog');
    const execCompleteButton = document.getElementById('exec-completeModal');
    const cancelCompleteButton = document.getElementById('cancel-completeModal');

    const sealsDesktopContainer = document.getElementById('sealsTableBody');
    const sealsMobileContainer = document.getElementById('sealsCards');

    let sealsData = [];
    let currentSealPlaces = []; // массив всех мест установки пломб
    let currentSealPlaceIndex = 0; // текущий индекс места установки
    let allSealPlacesData = {}; // данные всех мест установки

    // Причины замены
    const reasons = [
        "Износ пломбы",
        "Поверка средства измерения",
        "Повреждение пломбы",
        "Несанкционированное снятие",
        "Ввод в ручную",
    ];

    // --- шаблоны ---
    const reasonOptions = (selected) => {
        return `<option value="">Выберите причину</option>${reasons.map(r => `<option value="${r}" ${r === selected ? 'selected' : ''}>${r}</option>`).join('')}`;
    };

    const desktopRow = ({id, sealNumber, reason, newSealNumber, manualReason}) => `
      <tr data-id="${id}">
        <td><input class="form-input" value="${escapeHtml(sealNumber)}" readonly></td>
        <td>
            <select class="form-select" data-action="reason" data-id="${id}">
              ${reasonOptions(reason)}
            </select>

            ${reason === 'Ввод в ручную' ? `
                <input class="form-input mt-2"
                       data-action="manualReason"
                       data-id="${id}"
                       placeholder="Укажите причину"
                       value="${escapeHtml(manualReason || '')}">
            ` : ''}
        </td>
        <td><input class="form-input" data-action="newNumber" data-id="${id}" placeholder="Введите новый номер" value="${escapeHtml(newSealNumber || '')}"></td>
      </tr>`;

    const mobileCard = ({id, sealNumber, reason, newSealNumber, manualReason}) => `
      <div class="seal-card" data-id="${id}">
        <div class="seal-card__header">
          <span class="seal-card__label">Номер пломбы</span>
          <span class="seal-card__number">${escapeHtml(sealNumber)}</span>
        </div>
        <div class="seal-card__field">
            <label>Причина</label>
            <select class="form-select" data-action="reason" data-id="${id}">
              ${reasonOptions(reason)}
            </select>

            ${reason === 'Ввод в ручную' ? `
                <input class="form-input mt-2"
                       data-action="manualReason"
                       data-id="${id}"
                       placeholder="Укажите причину"
                       value="${escapeHtml(manualReason || '')}">
            ` : ''}
        </div>
        <div class="seal-card__field">
            <label>Новый номер</label>
            <input class="form-input" data-action="newNumber" data-id="${id}" placeholder="Введите новый номер" value="${escapeHtml(newSealNumber || '')}">
        </div>
      </div>`;

    // simple escape to avoid XSS when inserting values
    function escapeHtml(str) {
        if (str === null || str === undefined) return '';
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    // --- изменение поля ---
    function handleChange(e) {
        const el = e.target;
        const id = el.dataset.id;
        if (!id) return;

        const idx = sealsData.findIndex(s => String(s.id) === String(id));
        if (idx === -1) return;

        switch (el.dataset.action) {
            case 'reason':
                sealsData[idx].reason = el.value;
                break;

            case 'manualReason':
                sealsData[idx].manualReason = el.value;
                break;

            case 'newNumber':
                sealsData[idx].newSealNumber = el.value;
                break;
        }

        // Сохраняем данные для текущего места установки
        const currentSealPlaceId = currentSealPlaces[currentSealPlaceIndex]?.id;
        if (currentSealPlaceId) {
            allSealPlacesData[currentSealPlaceId] = [...sealsData];
        }

        if (el.dataset.action === 'reason') {
            renderSeals();
        }
    }

    // --- рендер пломб ---
    function renderSeals() {
        // desktop
        if (sealsDesktopContainer) {
            sealsDesktopContainer.innerHTML = sealsData.map(desktopRow).join('');
            // делегируем обработчики
            sealsDesktopContainer.querySelectorAll('[data-action="reason"], [data-action="newNumber"], [data-action="manualReason"]').forEach(el => {
                el.removeEventListener('change', handleChange);
                el.removeEventListener('input', handleChange);
                el.addEventListener('change', handleChange);
                el.addEventListener('input', handleChange);
            });
        }

        // mobile
        if (sealsMobileContainer) {
            sealsMobileContainer.innerHTML = sealsData.map(mobileCard).join('');
            sealsMobileContainer.querySelectorAll('[data-action="reason"], [data-action="newNumber"], [data-action="manualReason"]').forEach(el => {
                el.removeEventListener('change', handleChange);
                el.removeEventListener('input', handleChange);
                el.addEventListener('change', handleChange);
                el.addEventListener('input', handleChange);
            });
        }
    }

    // --- обновление навигации ---
    function updateNavigation() {
        const acceptBtn = document.getElementById('accept-sealDialog');
        const dialogTitle = sealsDialog.querySelector('.seals-dialog__title');

        if (!acceptBtn) return;

        // Создаем кнопку "Назад" если её нет
        let backBtn = document.getElementById('back-sealDialog');
        if (!backBtn) {
            backBtn = document.createElement('button');
            backBtn.id = 'back-sealDialog';
            backBtn.type = 'button';
            backBtn.className = 'btn btn--secondary';
            backBtn.textContent = 'Назад';
            backBtn.addEventListener('click', goToPreviousSealPlace);
            acceptBtn.parentNode.insertBefore(backBtn, acceptBtn);
        }

        // Показываем/скрываем кнопку "Назад"
        backBtn.style.display = currentSealPlaceIndex > 0 ? 'inline-block' : 'none';

        // Обновляем текст кнопки "Принять"
        if (currentSealPlaceIndex === currentSealPlaces.length - 1) {
            acceptBtn.textContent = 'Сохранить';
        } else {
            acceptBtn.textContent = 'Далее';
        }

        // Обновляем заголовок
        if (dialogTitle && currentSealPlaces[currentSealPlaceIndex]) {
            const sealPlace = currentSealPlaces[currentSealPlaceIndex];

            dialogTitle.innerHTML = `
            Замена пломб (${currentSealPlaceIndex + 1}/${currentSealPlaces.length})
            <div class="seals-dialog__subtitle">${escapeHtml(sealPlace.place)}</div>
        `;
        }
    }

    // --- переход к следующему месту установки ---
    function goToNextSealPlace() {
        // Сначала сохраняем и проверяем текущие данные
        if (!validateCurrentSealPlace()) {
            return; // Если валидация не прошла, не переходим дальше
        }

        if (currentSealPlaceIndex < currentSealPlaces.length - 1) {
            currentSealPlaceIndex++;
            loadCurrentSealPlaceData();
        }
    }

    // --- переход к предыдущему месту установки ---
    function goToPreviousSealPlace() {
        const currentSealPlaceId = currentSealPlaces[currentSealPlaceIndex]?.id;
        if (currentSealPlaceId) {
            allSealPlacesData[currentSealPlaceId] = [...sealsData];
        }

        if (currentSealPlaceIndex > 0) {
            currentSealPlaceIndex--;
            loadCurrentSealPlaceData();
        }
    }

    // --- загрузка данных текущего места установки ---
    function loadCurrentSealPlaceData() {
        const currentSealPlaceId = currentSealPlaces[currentSealPlaceIndex]?.id;
        if (currentSealPlaceId && allSealPlacesData[currentSealPlaceId]) {
            // Загружаем сохраненные данные
            sealsData = [...allSealPlacesData[currentSealPlaceId]];
        } else {
            // Инициализируем новые данные только для текущего места установки
            const currentSealPlace = currentSealPlaces[currentSealPlaceIndex];
            sealsData = getSealPlaceData(currentSealPlace);
        }
        renderSeals();
        updateNavigation();
    }

    // --- получение данных пломб для конкретного места установки ---
    function getSealPlaceData(sealPlace) {
        const sealsData = [];

        sealPlace.numbers.forEach((number, i) => {
            sealsData.push({
                id: sealPlace.id + '_' + i,
                sealNumber: number,
                reason: '',
                manualReason: '',
                newSealNumber: ''
            });
        });

        return sealsData;
    }

    // --- собрать все места установки с НЕотмеченными пломбами ---
    function collectAllSealPlaces(currentEditBtn) {
        const sealPlaces = [];
        // Находим все места установки пломб (label с классом act-info__seal)
        const sealLabels = currentEditBtn.closest('#block_seals').querySelectorAll('label.act-info__seal');

        sealLabels.forEach(label => {
            const checkbox = label.querySelector('.js-select-seal');

            // Проверяем, что чекбокс существует и НЕ отмечен
            if (checkbox && !checkbox.checked) {
                const sealId = checkbox.dataset.sealId;
                const placeElement = label.querySelector('[data-place]');
                const numbersElement = label.querySelector('[data-numbers]');

                if (placeElement && numbersElement) {
                    const place = placeElement.dataset.place;
                    const numbersRaw = numbersElement.dataset.numbers || '';
                    const numbers = numbersRaw.toString().split(/\s*,\s*/).filter(Boolean);

                    if (numbers.length > 0) {
                        sealPlaces.push({
                            id: sealId,
                            place: place,
                            numbers: numbers,
                            element: label
                        });
                    }
                }
            }
        });

        return sealPlaces;
    }

    // --- открыть диалог и загрузить данные ---
    async function openButtonHandler() {
        try {
            // Собираем все места установки с НЕотмеченными пломбами
            currentSealPlaces = collectAllSealPlaces(this);

            if (currentSealPlaces.length === 0) {
                showModal('Нет пломб для замены', 'Информация');
                return;
            }

            // Сбрасываем индекс и данные
            currentSealPlaceIndex = 0;
            allSealPlacesData = {};

            // Загружаем данные для первого места установки
            loadCurrentSealPlaceData();

            const $meter = $(this).closest('[data-meter-id]');
            if ($meter.length) {
                const meter_id = $meter.data('meter-id');
                $('#sealDialog').find('#meter-id').val(meter_id);
            }

            // Показываем диалог
            sealsDialog && sealsDialog.showModal();
        } catch (err) {
            const message = err?.message || err?.responseText || 'Ошибка получения данных';
            showModal(message, 'Ошибка');
        }
    }

    // Привязываем обработчик к кнопке
    if (openButton) {
        openButton.forEach(btn => {
            btn.addEventListener('click', openButtonHandler);
        })
    }

    // --- проверка валидности данных для текущего места установки ---
    function validateCurrentSealPlace() {
        const currentSealPlaceId = currentSealPlaces[currentSealPlaceIndex]?.id;
        if (currentSealPlaceId) {
            allSealPlacesData[currentSealPlaceId] = [...sealsData];
        }

        // Проверяем валидность данных для текущего места установки
        const allFilled = sealsData.every(s => {
            // Если ни одно поле не заполнено - пропускаем
            if ((!s.reason || s.reason.trim() === '') && (!s.newSealNumber || s.newSealNumber.trim() === '')) {
                return true;
            }

            if (s.reason === 'Ввод в ручную') {
                return s.manualReason && s.manualReason.trim() !== '' && s.newSealNumber && s.newSealNumber.trim() !== '';
            }

            // Если хотя бы одно поле заполнено - оба должны быть заполнены
            return (s.reason && s.reason.trim() !== '') && (s.newSealNumber && s.newSealNumber.trim() !== '');
        });

        if (!allFilled) {
            showModal('Заполните причину и новый номер во всех выбранных пломбах. Для "Ввода в ручную" укажите причину в дополнительном поле.', 'Ошибка');
            return false;
        }

        const toSave = sealsData.filter(s => {
            if (s.reason === 'Ввод в ручную') {
                return s.manualReason && s.manualReason.trim() !== '' && s.newSealNumber && s.newSealNumber.trim() !== '';
            }
            return s.reason && s.reason.trim() !== '' && s.newSealNumber && s.newSealNumber.trim() !== '';
        });

        // Для промежуточных шагов не требуем обязательного заполнения, только валидацию формата
        // Для последнего шага проверяем, что есть хотя бы одна заполненная пломба
        if (currentSealPlaceIndex === currentSealPlaces.length - 1 && toSave.length === 0) {
            showModal('Заполните хотя бы одну строку (причина + новый номер) для сохранения', 'Ошибка');
            return false;
        }

        return true;
    }

    // --- Функционал добавления пломб ---

// Обработчик открытия диалога добавления пломб
    async function openAddSealDialog() {
        // Очищаем форму
        addSealLocationInput.innerHTML = '<option value="">Выберите местоположение</option>';
        sealNumbersContainer.innerHTML = `
        <div class="seal-number-row">
            <input type="text" class="form-input" placeholder="Введите номер пломбы">
            <button type="button" class="btn btn--icon btn--danger remove-seal-number" style="display: none;">
                <i class="fas fa-times"></i>
            </button>
        </div>
    `;

        // Сохраняем meter_id
        const $meter = $(this).closest('[data-meter-id]');
        let meterId = null;
        if ($meter.length) {
            meterId = $meter.data('meter-id');
            $('#add-meter-id').val(meterId);
        }

        // Загружаем места
        if (meterId) {
            try {
                const resp = await ajax(`/seals/places`, {
                    method: 'GET'
                });

                if (resp.success && resp.places && resp.places.length > 0) {
                    resp.places.forEach(place => {
                        const option = document.createElement('option');
                        option.value = place.guid;
                        option.textContent = place.name;
                        addSealLocationInput.appendChild(option);
                    });
                }
            } catch (err) {
                console.error('Ошибка загрузки мест:', err);
            }
        }

        sealAddDialog && sealAddDialog.showModal();
    }

// Добавление поля для номера пломбы
    function addSealNumberField() {
        const sealNumberRow = document.createElement('div');
        sealNumberRow.className = 'seal-number-row';
        sealNumberRow.innerHTML = `
        <input type="text" class="form-input" placeholder="Введите номер пломбы">
        <button type="button" class="btn btn--icon btn--danger remove-seal-number">
            <i class="fas fa-times"></i>
        </button>
    `;

        sealNumbersContainer.appendChild(sealNumberRow);

        // Показываем кнопки удаления у всех строк, если их больше одной
        updateRemoveButtonsVisibility();
    }

// Удаление поля номера пломбы
    function removeSealNumberField(button) {
        const row = button.closest('.seal-number-row');
        if (row) {
            row.remove();
            updateRemoveButtonsVisibility();
        }
    }

// Обновление видимости кнопок удаления
    function updateRemoveButtonsVisibility() {
        const rows = sealNumbersContainer.querySelectorAll('.seal-number-row');
        const removeButtons = sealNumbersContainer.querySelectorAll('.remove-seal-number');

        // Показываем кнопки удаления только если строк больше одной
        if (rows.length > 1) {
            removeButtons.forEach(btn => btn.style.display = 'inline-block');
        } else {
            removeButtons.forEach(btn => btn.style.display = 'none');
        }
    }

// Сохранение добавленных пломб
    async function saveAddedSeals() {
        const location = addSealLocationInput.value.trim();
        const meter_id = $('#add-meter-id').val();
        const actEl = document.getElementById('block_act');
        const act_id = actEl ? actEl.dataset.actId || actEl.dataset['act-id'] : null;

        // Валидация
        if (!location) {
            showModal('Введите местоположение пломб', 'Ошибка');
            return;
        }

        // Собираем номера пломб
        const numberInputs = sealNumbersContainer.querySelectorAll('.form-input');
        const numbers = Array.from(numberInputs)
            .map(input => input.value.trim())
            .filter(number => number !== '');

        if (numbers.length === 0) {
            showModal('Введите хотя бы один номер пломбы', 'Ошибка');
            return;
        }

        try {
            const resp = await ajax('/seals/add', {
                method: 'POST',
                body: {
                    act_id,
                    meter_id,
                    location,
                    numbers
                }
            });

            // Обновляем UI
            if (resp.html) {
                const blockSeals = document.getElementById('block_seals');
                if (blockSeals) blockSeals.innerHTML = resp.html;

                // Перепривязываем обработчики
                document.querySelectorAll('.js-seal-replace').forEach(btn => {
                    btn.addEventListener('click', openButtonHandler);
                });
                document.querySelectorAll('.js-seal-add').forEach(btn => {
                    btn.addEventListener('click', openAddSealDialog);
                });
            }

            showModal('Пломбы успешно добавлены', 'Готово');
            sealAddDialog.close();

        } catch (err) {
            console.error('Ошибка добавления пломб:', err);
            const message = err?.message || 'Ошибка добавления пломб';
            showModal(message, 'Ошибка');
        }
    }

// Привязка событий для добавления пломб
    if (addSealButton) {
        addSealButton.addEventListener('click', openAddSealDialog);
    }

    if (cancelAddButton) {
        cancelAddButton.addEventListener('click', () => sealAddDialog.close());
    }

    if (acceptAddButton) {
        acceptAddButton.addEventListener('click', saveAddedSeals);
    }

    if (addSealNumberButton) {
        addSealNumberButton.addEventListener('click', addSealNumberField);
    }

// Обработчик удаления полей (делегирование)
    if (sealNumbersContainer) {
        sealNumbersContainer.addEventListener('click', (e) => {
            if (e.target.closest('.remove-seal-number')) {
                removeSealNumberField(e.target.closest('.remove-seal-number'));
            }
        });
    }

// Закрытие диалога по клику на backdrop
    if (sealAddDialog) {
        sealAddDialog.addEventListener('click', (event) => {
            if (event.target === sealAddDialog) sealAddDialog.close();
        });
    }

    // --- принять (сохранить/перейти далее) ---
    async function accept() {
        // Сохраняем данные текущего места установки
        const currentSealPlaceId = currentSealPlaces[currentSealPlaceIndex]?.id;
        if (currentSealPlaceId) {
            allSealPlacesData[currentSealPlaceId] = [...sealsData];
        }

        const allFilled = sealsData.every(s => {
            if ((!s.reason || s.reason.trim() === '') && (!s.newSealNumber || s.newSealNumber.trim() === '')) {
                return true;
            }

            if (s.reason === 'Ввод в ручную') {
                return s.manualReason && s.manualReason.trim() !== '' && s.newSealNumber && s.newSealNumber.trim() !== '';
            }

            return (s.reason && s.reason.trim() !== '') && (s.newSealNumber && s.newSealNumber.trim() !== '');
        });

        if (!allFilled) {
            showModal('Заполните причину и новый номер во всех выбранных пломбах. Для "Ввода в ручную" укажите причину в дополнительном поле.', 'Ошибка');
            return;
        }

        const toSave = sealsData.filter(s => {
            if (s.reason === 'Ввод в ручную') {
                return s.manualReason && s.manualReason.trim() !== '' && s.newSealNumber && s.newSealNumber.trim() !== '';
            }
            return s.reason && s.reason.trim() !== '' && s.newSealNumber && s.newSealNumber.trim() !== '';
        });

        // Если это не последнее место установки - переходим к следующему
        if (currentSealPlaceIndex < currentSealPlaces.length - 1) {
            // Проверяем, что есть хотя бы одна заполненная пломба для продолжения
            if (toSave.length === 0) {
                showModal('Заполните хотя бы одну пломбу (причина + новый номер) для продолжения', 'Ошибка');
                return;
            }
            goToNextSealPlace();
            return;
        }

        // Если это последнее место установки - проверяем, что есть данные для сохранения
        if (toSave.length === 0) {
            showModal('Заполните хотя бы одну строку (причина + новый номер) для сохранения', 'Ошибка');
            return;
        }

        // Сохраняем все данные
        await saveAllSealPlacesData();
    }

    // --- сохранение данных всех мест установки ---
    async function saveAllSealPlacesData() {
        try {
            const actEl = document.getElementById('block_act');
            const act_id = actEl ? actEl.dataset.actId || actEl.dataset['act-id'] : null;

            const meter_id = $('#sealDialog').find('#meter-id').val();

            if (!meter_id) {
                showModal('Ошибка: не удалось определить прибор учета', 'Ошибка');
                return;
            }

            // Собираем данные для всех мест установки
            const allPayload = [];
            const allCheckedSeals = [];

            for (const sealPlace of currentSealPlaces) {
                const sealPlaceData = allSealPlacesData[sealPlace.id] || [];
                const payload = sealPlaceData.filter(s => {
                    if (s.reason === 'Ввод в ручную') {
                        return s.manualReason && s.manualReason.trim() !== '' && s.newSealNumber && s.newSealNumber.trim() !== '';
                    }
                    return s.reason && s.reason.trim() !== '' && s.newSealNumber && s.newSealNumber.trim() !== '';
                }).map(s => ({
                    id: s.id,
                    currentSeal: s.sealNumber,
                    reason: s.reason === 'Ввод в ручную' ? s.manualReason : s.reason,
                    newSeal: s.newSealNumber.trim(),
                    isManualInput: s.reason === 'Ввод в ручную'
                }));

                if (payload.length > 0) {
                    allPayload.push(...payload);
                    allCheckedSeals.push(sealPlace.id);
                }
            }

            // Если нет данных для сохранения
            if (allPayload.length === 0) {
                showModal('Нет данных для сохранения', 'Информация');
                sealsDialog && sealsDialog.close();
                return;
            }

            const resp = await ajax('/seals', {
                method: 'PATCH',
                body: {
                    act_id,
                    meter_id,
                    seals: allPayload,
                    checkedSeals: allCheckedSeals
                }
            });

            // Обновляем UI
            if (resp.html || (resp.data && resp.data.html)) {
                const html = resp.html || resp.data.html;
                const blockSeals = document.getElementById('block_seals');
                if (blockSeals) blockSeals.innerHTML = html;

                // Перепривязываем обработчики
                document.querySelectorAll('.js-seal-replace').forEach(btn => {
                    btn.addEventListener('click', openButtonHandler);
                });
            }

            showModal('Данные успешно сохранены', 'Готово');
            sealsDialog && sealsDialog.close();

        } catch (err) {
            const message = err?.message || 'Ошибка сохранения пломб';
            showModal(message, 'Ошибка');
        }
    }

    // --- execute / complete task ---
    async function execute(send = false) {
        try {

            await ajax('/act/status', {
                method: 'PATCH',
                body: { act_id: $('#block_act').data('act-id'), status: 'Выполнен' }
            });

            document.getElementById('act-status') && (document.getElementById('act-status').textContent = 'Выполнен');
            if (sendDialog) sendActButton.disabled = false;
            if (completeTaskButton) completeTaskButton.disabled = true;
            if (actActionBtn) actActionBtn.disabled = true;

            if (send) sendDialog && sendDialog.showModal();

        } catch (err) {
            const message = err?.message || 'Ошибка при завершении акта';
            showModal(message, 'Ошибка');
        }

        confirmTaskDialog && confirmTaskDialog.close();
    }

    // --- отправка на email ---
    async function send() {
        const dialog = sendDialog;
        if (!dialog) return;
        const emailInput = dialog.querySelector('input[type="email"]');
        if (emailInput && emailInput.classList.contains('error')) {
            showModal('Введите корректный email', 'Ошибка');
            return;
        }
        const currentEmailEl = dialog.querySelector('.dialog__body___email');
        const currentEmail = currentEmailEl ? currentEmailEl.textContent.trim() : '';
        const newEmail = emailInput ? emailInput.value.trim() : '';
        const actEl = document.getElementById('block_act');
        const act_id = actEl ? actEl.dataset.actId || actEl.dataset['act-id'] : null;
        const contactId = actEl ? actEl.dataset.contactId || actEl.dataset['contact-id'] : null;
        const updateEmail = (newEmail && newEmail !== currentEmail);

        try {
            const resp = await ajax(`/act/${act_id}/send`, {
                method: 'POST',
                body: { act_id, email: newEmail || currentEmail, contactId, updateEmail, message: 'Тестовое сообщение' }
            });

            if (resp.error) {
                showModal(resp.error, 'Ошибка');
            } else {
                // обновляем UI
                if (currentEmailEl && (newEmail || currentEmail)) currentEmailEl.textContent = newEmail || currentEmail;
                if (sendActButton) sendActButton.disabled = true;
                const blockAct = document.getElementById('block_act');
                if (blockAct && resp.dateTime) {
                    blockAct.insertAdjacentHTML('beforeend', `
                        <div class="act-info__row">
                            <div class="act-info__field">Акт направлен:</div>
                            <div class="act-info__value">${escapeHtml(resp.dateTime)}</div>
                        </div>
                    `);
                }
                showModal(resp.success || 'Акт отправлен', 'Готово');
            }
        } catch (err) {
            const message = err?.message || 'Сбой соединения';
            showModal(message, 'Ошибка');
        }

        sendDialog && sendDialog.close();
    }

    // --- создание агента ---
    createAgentButton.addEventListener('click', () => {
        createAgentDialog.showModal();
    });

    //открыть модалку изменения участников
    alterParticipantButton.addEventListener('click', async (e) => {
        participantDialog.showModal();
        await loadParticipants();
    })

    async function createAgent(ev) {
        try {
            const form = this.closest('form') || document.querySelector('#newAgentForm form');
            if (!form) throw new Error('Форма не найдена');
            const fd = new FormData(form);
            const $block = document.getElementById('block_contact');
            const enterpriseId = $block ? ($block.dataset.enterpriseId || $block.dataset['enterprise-id']) : null;
            fd.append('enterprise_id', enterpriseId);

            const actEl = document.getElementById('block_act');
            const act_id = actEl ? actEl.dataset.actId || actEl.dataset['act-id'] : null;

            if (!act_id) {
                showModal('Не удалось определить акт', 'Ошибка');
                return;
            }
            fd.append('act_id', act_id);

            const resp = await ajax(`/enterprise/${enterpriseId}/agent`, {
                method: 'POST',
                body: fd
            });

            // ожидаем html обновлённого блока
            if (resp.html || (resp.data && resp.data.html)) {
                const html = resp.html || resp.data.html;
                const block = document.getElementById('block_contact');
                if (block){
                    block.innerHTML = html;
                    document.getElementById('createAgent').addEventListener('click', () => {
                        createAgentDialog.showModal();
                    });
                    document.getElementById('alter-participant').addEventListener('click', async (e) => {
                        participantDialog.showModal();
                        await loadParticipants();
                    })
                }
            }

            // очистка формы
            form.querySelectorAll('input').forEach(i => i.value = '');
            createAgentDialog && createAgentDialog.close();
        } catch (err) {
            const message = err?.message || 'Ошибка создания агента';
            showModal(message, 'Ошибка');
        }
    }

    // Функция загрузки участников
    async function loadParticipants() {
        try {
            const actEl = document.getElementById('block_act');
            const act_id = actEl ? actEl.dataset.actId || actEl.dataset['act-id'] : null;

            if (!act_id) {
                showModal('Не удалось определить акт', 'Ошибка');
                return;
            }

            const resp = await ajax(`/act/${act_id}/participants`, {
                method: 'GET'
            });

            // Рендерим список участников
            renderParticipants(resp.participants);

        } catch (err) {
            console.error('Ошибка загрузки участников:', err);
            const message = err?.message || 'Ошибка загрузки списка участников';
            showModal(message, 'Ошибка');
        }
    }

    // Функция рендера списка участников
    function renderParticipants(participants) {
        if (!participantsContainer) return;

        participantsContainer.innerHTML = participants.map(participant => `
        <div class="participant-item" style="margin-bottom: 10px; padding: 8px; border-bottom: 1px solid #eee;">
            <label style="display: flex; align-items: center; cursor: pointer;">
                <input type="checkbox"
                       name="participant_ids[]"
                       value="${participant.id}"
                       ${participant.is_selected ? 'checked' : ''}
                       data-participant-id="${participant.id}"
                       style="margin-right: 10px;">
                <span style="font-size: 14px;">${escapeHtml(participant.full_string)}</span>
            </label>
        </div>
    `).join('');
    }

    // Функция сохранения выбранных участников
    async function saveParticipants() {
        try {
            const checkedParticipants = Array.from(
                participantsContainer.querySelectorAll('input[type="checkbox"]:checked')
            ).map(checkbox => parseInt(checkbox.value));

            const actEl = document.getElementById('block_act');
            const act_id = actEl ? actEl.dataset.actId || actEl.dataset['act-id'] : null;

            if (checkedParticipants.length === 0) {
                showModal('Выберите хотя бы одного участника', 'Ошибка');
                return;
            }

            const resp = await ajax(`/act/${act_id}/participants/update`, {
                method: 'POST',
                body: {
                    participant_ids: checkedParticipants
                }
            });

            if (resp.success) {
                showModal(resp.message, 'Готово');
                participantDialog.close();
            } else {
                showModal(resp.error || 'Ошибка сохранения', 'Ошибка');
            }

        } catch (err) {
            console.error('Ошибка сохранения участников:', err);
            const message = err?.message || 'Ошибка сохранения состава участников';
            showModal(message, 'Ошибка');
        }
    }

    // --- cancel all dialogs ---
    function cancel() {
        [sealsDialog, sendDialog, createAgentDialog, confirmTaskDialog, participantDialog].forEach(d => d && d.close && d.close());
    }

    // complete task
    completeTaskButton.addEventListener('click', () => {
        let allFieldsFilled = true
        document.querySelectorAll('input, select, textarea[name="resolution"]').forEach(field => {
            if (field.closest('dialog') || field.type === 'hidden' || field.type === 'checkbox' || field.type === 'search') {
                return;
            }
            if (!field.value.trim() || (field.type === 'number' && field.value === '0')) {
                allFieldsFilled = false;
                field.style.borderColor = 'red';
                if (field.tagName === 'SELECT') {
                    field.nextElementSibling.children[0].firstElementChild.style.borderColor = 'red';
                }
            } else {
                field.style.borderColor = '';
            }
        })
        if (!allFieldsFilled) {
            completeTaskModal.showModal();
            return;
        }
        confirmTaskDialog.showModal();
    });

    // send email button
    sendActButton.addEventListener('click', () => {
        sendDialog.showModal();
    });

    // binding buttons
    cancelButton && cancelButton.addEventListener('click', cancel);
    acceptButton && acceptButton.addEventListener('click', accept);
    cancelEmailButton && cancelEmailButton.addEventListener('click', cancel);
    sendEmailButton && sendEmailButton.addEventListener('click', send);
    acceptAgentButton && acceptAgentButton.addEventListener('click', createAgent);
    cancelAgentButton && cancelAgentButton.addEventListener('click', cancel);
    completeConfirmButton && completeConfirmButton.addEventListener('click', () => execute(true));
    execConfirmButton && execConfirmButton.addEventListener('click', () => execute());
    cancelConfirmButton && cancelConfirmButton.addEventListener('click', cancel);
    cancelCompleteButton.addEventListener('click', () => completeTaskModal.close())
    execCompleteButton.addEventListener('click', () => {
        completeTaskModal.close();
        confirmTaskDialog.showModal();
    })

    cancelParticipantButton && cancelParticipantButton.addEventListener('click', cancel);
    saveParticipantButton && saveParticipantButton.addEventListener('click', saveParticipants);

    // backdrop close behavior for sealsDialog
    if (sealsDialog) {
        sealsDialog.addEventListener('click', (event) => {
            if (event.target === sealsDialog) sealsDialog.close();
        });
    }

    // email input validation binding (if exists)
    if (sendDialog) {
        const cb = sendDialog.querySelector('input[type=checkbox]');
        const emailInput = cb ? cb.closest('label').nextElementSibling : sendDialog.querySelector('input[type=email]');
        const info = sendDialog.querySelector('.send-email-info') || (function(){
            const el = document.createElement('div');
            el.className = 'send-email-info';
            el.style.color = 'red';
            el.style.fontSize = '12px';
            el.style.display = 'none';
            return el;
        })();

        if (emailInput && !emailInput.nextElementSibling) {
            emailInput.insertAdjacentElement('afterend', info);
        }

        if (emailInput) {
            $(emailInput).inputmask({
                mask: "*{1,80}@*{1,80}[.*{2,7}][.*{2,3}]",
                greedy: false,
                onBeforePaste: function (pastedValue) {
                    pastedValue = pastedValue.toLowerCase();
                    return pastedValue.replace("mailto:", "");
                },
                definitions: {
                    '*': {
                        validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
                        cardinality: 1,
                        casing: "lower"
                    }
                }
            });

            emailInput.addEventListener('blur', e => {
                const email = e.target.value.trim();
                if (!email) {
                    info.style.display = 'none';
                    emailInput.classList.remove('error');
                    return;
                }
                const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;
                if (!emailRegex.test(email)) {
                    info.textContent = 'Введите корректный email';
                    info.style.display = 'block';
                    emailInput.classList.add('error');
                } else {
                    info.style.display = 'none';
                    emailInput.classList.remove('error');
                }
            });

            if (cb) {
                cb.addEventListener('change', e => {
                    emailInput.disabled = !e.target.checked;
                    if (!e.target.checked) emailInput.value = '';
                });
            }
        }
    }
});
